import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Select from 'react-select';
import darkSelectStyles from '../../../shared/darkSelectStyles';

const FunctionSelect = ({ teamFunctions, values, onChange, onCreate }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [newName, setNewName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const options = teamFunctions.map((f) => ({ value: f.id, label: f.name }));
  options.push({ value: "__add_new__", label: "+ Add new function" });

  const selectedSet = new Set(values || []);
  const selectedOptions = options.filter((o) => selectedSet.has(o.value));

  const handleChange = (chosen) => {
    const nextOptions = chosen || [];
    if (nextOptions.some((o) => o.value === "__add_new__")) {
      setIsAdding(true);
      setNewName("");
      // Strip the sentinel from selection so it does not persist as an id
      onChange(nextOptions.filter((o) => o.value !== "__add_new__").map((o) => o.value));
    } else {
      onChange(nextOptions.map((o) => o.value));
    }
  };

  const submitNew = async () => {
    const trimmed = newName.trim();
    if (!trimmed) return;
    setSubmitting(true);
    try {
      const created = await onCreate(trimmed);
      if (created?.id) {
        onChange([...(values || []), created.id]);
      }
      setIsAdding(false);
      setNewName("");
    } finally {
      setSubmitting(false);
    }
  };

  if (isAdding) {
    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <input
          type="text"
          autoFocus
          className="team-form-input"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="New function name"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              submitNew();
            } else if (e.key === "Escape") {
              setIsAdding(false);
            }
          }}
        />
        <button type="button" className="team-btn-primary" disabled={submitting} onClick={submitNew}>
          {submitting ? "Adding…" : "Add"}
        </button>
        <button type="button" className="team-btn-secondary" onClick={() => setIsAdding(false)}>
          Cancel
        </button>
      </div>
    );
  }

  return (
    <Select
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      placeholder="Select function(s) (optional)"
      isClearable
      isMulti
      styles={darkSelectStyles}
    />
  );
};

FunctionSelect.propTypes = {
  teamFunctions: PropTypes.array.isRequired,
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  onChange: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

FunctionSelect.defaultProps = {
  values: [],
};

export default FunctionSelect;
